export default function Terms2() {
    return (
        <>
            <p>【개인정보 수집.이용 동의서】</p>
            <p>(주)코엑스 및 (주)지에스아이엘(이하 “회사”)는 개인정보보호법 등 관련 법령상의 개인정보 보호 규정을 준수하며 이용자의 개인정보 보호에 최선을 다하고 있습니다. 회사는 개인정보보호법 제15조 및 동 법 제22조에 의거하여, 서비스의 원활한 이용을 위하여 개인정보를 수집.이용 및 제3자 제공 동의를 받고자 합니다.</p>
            <p>□ 개인정보 수집·이용 동의</p>
            <table>
                <tbody>
                <tr>
                    <td className='border' colSpan={1}>수집 목적</td>
                    <td className='border' colSpan={4}>회원가입 및 서비스 이용</td>
                </tr>
                <tr>
                    <td className='border'  colSpan={1}>수집 항목</td>
                    <td className='border' colSpan={4}>
                        <p>[공통 필수]</p>
                        <p>비밀번호, 성명, 성별, 휴대전화번호, 회사명, 행사명</p>
                        <p>[선택]</p>
                        <p>이메일, 건설업 기초 안전보건교육 이수일, 본인 사진(정면)</p>
                    </td>
                </tr>
                <tr>
                    <td className='border' colSpan={1}>보유 및{'\n'}이용기간</td>
                    <td className='border' colSpan={4}>서비스 회원 탈퇴 후 3년</td>
                </tr>
                </tbody>
            </table>
            <p>※ 동의거부권 및 동의 거부에 따른 불이익 안내</p>
            <p>본인은 위와 같이 개인정보를 수집.이용하는 데 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 회사에서 제공하는 서비스를 받을 수 없음을 참고하시기 바랍니다.</p>
            <p>■ 그 밖에 개인정보 취급에 관한 자세한 사항은「전시장 맞춤 통합안전플랫폼」 (S100 MICE)에서 공개하고 있는 “개인정보 처리방침”을 참고하시기 바랍니다.</p>
        </>
    );
}